import { createContext } from "react";
import { type Language } from "@/lib/languages";

export interface LanguageContextType {
  currentLanguage: string;
  currentLanguageObj: Language;
  setLanguage: (code: string) => void;
  isLoading: boolean;
  supportedLanguages: Language[];
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
